import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import {
  changeCategoryResult,
  createRuleResponse,
  deleteRuleResponse,
  getConfigurationResponse,
  getItemPattern,
  getMLStoresResponse,
  getModelStatusResponse,
  getRules,
  listItemDetailsResult,
  listMainItemsResult,
  listSelectableItemsResponse,
  updateConfigurationResponse,
  updateStoreConfigurationResponse,
} from './fixtures/ml-service.fixtures';

const domain = `${getEnv('REACT_APP_ADMIN_API_URL')}/ml/portal`;

export const listMainItemsMock = fn =>
  rest.get(`${domain}/client/mainitem/names/:clientId`, fn);
export const listItemsDetailsMock = fn =>
  rest.get(`${domain}/client/item/name/details/:clientId`, fn);

export const getItemPatternMock = fn => rest.post(`${domain}/pattern`, fn);

export const getRulesMock = fn =>
  rest.get(`${domain}/client/rules/:clientId`, fn);

export const createRuleMock = fn => rest.post(`${domain}/client/rules`, fn);

export const deleteRuleMock = fn => rest.put(`${domain}/client/rules`, fn);

export const listSelectableItemsMock = fn =>
  rest.get(`${domain}/client/names/:clientId`, fn);

export const changeCategoryMock = fn =>
  rest.put(`${domain}/client/item/category/change`, fn);

export const getModelStatusMock = fn =>
  rest.get(`${domain}/client/model/status/:clientId`, fn);

export const getConfigurationMock = fn =>
  rest.get(`${domain}/client/configuration/:clientId`, fn);

export const submitConfigurationMock = fn =>
  rest.put(`${domain}/client/configuration`, fn);

export const getMLStoresMock = fn =>
  rest.get(`${domain}/client/location/:clientId`, fn);

export const updateStoreConfigurationMock = fn =>
  rest.put(`${domain}/client/location/:clientId`, fn);

export const handlers = () => [
  listMainItemsMock((_req, res, ctx) => res(ctx.json(listMainItemsResult))),
  listItemsDetailsMock((_req, res, ctx) =>
    res(ctx.json(listItemDetailsResult)),
  ),
  getItemPatternMock((_req, res, ctx) => res(ctx.json(getItemPattern))),
  getRulesMock((_req, res, ctx) => res(ctx.json(getRules))),
  createRuleMock((_req, res, ctx) => res(ctx.json(createRuleResponse))),
  deleteRuleMock((_req, res, ctx) => res(ctx.json(deleteRuleResponse))),
  listSelectableItemsMock((_req, res, ctx) =>
    res(ctx.json(listSelectableItemsResponse)),
  ),
  changeCategoryMock((_req, res, ctx) => res(ctx.json(changeCategoryResult))),
  getModelStatusMock((_req, res, ctx) => res(ctx.json(getModelStatusResponse))),
  getConfigurationMock((_req, res, ctx) =>
    res(ctx.json(getConfigurationResponse)),
  ),
  submitConfigurationMock((_req, res, ctx) =>
    res(ctx.json(updateConfigurationResponse)),
  ),
  getMLStoresMock((_req, res, ctx) => res(ctx.json(getMLStoresResponse))),
  updateStoreConfigurationMock((_req, res, ctx) =>
    res(ctx.json(updateStoreConfigurationResponse)),
  ),
];
